/* AuthCallback — Emergent Google Auth redirect handler.
   Kullanıcı Google auth'tan dönerken #session_id=... ile gelir.
   Bunu yakalayıp /api/auth/google/exchange'e gönderir, JWT alır, localStorage'a yazar.

   REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
*/
import React, { useEffect, useRef } from 'react';
import axios from 'axios';
import { toast } from 'sonner';

const API = process.env.REACT_APP_BACKEND_URL;

export default function AuthCallback() {
    const handled = useRef(false);

    useEffect(() => {
        if (handled.current) return;
        handled.current = true;

        const hash = window.location.hash || '';
        const params = new URLSearchParams(hash.startsWith('#') ? hash.slice(1) : hash);
        const sessionId = params.get('session_id');

        if (!sessionId) {
            toast.error('Session ID yok');
            window.location.replace('/signin');
            return;
        }

        (async () => {
            try {
                const r = await axios.post(`${API}/api/auth/google/exchange`, { session_id: sessionId });
                const { token, user, company, is_new_user } = r.data || {};
                if (!token) throw new Error('Token alınamadı');

                localStorage.setItem('token', token);
                localStorage.setItem('user', JSON.stringify(user));
                if (company) localStorage.setItem('company', JSON.stringify(company));

                if (is_new_user) {
                    toast.success(`Hoş geldin ${user.full_name}! Hesabın oluşturuldu.`);
                } else {
                    toast.success(`Tekrar hoş geldin ${user.full_name}!`);
                }
                // Tam sayfa reload — AuthContext fresh init olsun, /auth/me ile user state'i kurulsun.
                // React Router'ın navigate'i yeterli değil çünkü AuthContext zaten bir kez mount oldu
                // ve user state'i null kaldı; bu durumda ProtectedRoute landing'e atar.
                const target = user?.role === 'super_admin' ? '/superadmin' : '/dashboard';
                window.location.replace(target);
            } catch (e) {
                console.error(e);
                toast.error(e.response?.data?.detail || 'Giriş başarısız');
                window.location.replace('/signin');
            }
        })();
    }, []);

    return (
        <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-blue-50 to-indigo-50">
            <div className="bg-white rounded-xl shadow-lg p-8 text-center max-w-sm">
                <div className="w-12 h-12 border-4 border-blue-500 border-t-transparent rounded-full animate-spin mx-auto mb-4"></div>
                <h2 className="text-lg font-bold text-gray-900 mb-1">Giriş yapılıyor...</h2>
                <p className="text-sm text-gray-600">Google hesabınla bağlantı kuruluyor</p>
            </div>
        </div>
    );
}
